import script from "./ClientProjectVariableSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectVariableSelector.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectVariableSelector.vue?vue&type=style&index=0&id=3d85f878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d85f878"]])

export default __exports__